module.exports = __webpack_public_path__ + "static/media/4.2.3-tags.1bfa397e.png";